import Tooltip from "tooltip.js";

document.addEventListener('DOMContentLoaded',function(){
    document.querySelectorAll('.tip').forEach((element) => {
        let title = element.getAttribute('title');
        element.removeAttribute('title');
        element.setAttribute('data-title', title);
        new Tooltip(element, {
            title: () => {
                return element.getAttribute('data-title');
            }
        });
    });
});
